module.exports = __webpack_public_path__ + "img/slide1-3.b6c7cdc6.png";